import App from '@/App'
import '@/i18n'
import { render } from 'preact'

console.log({ env: import.meta.env })
render(<App />, document.body)

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js', { type: 'module' }).then((registration) => {
        registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            newWorker?.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    newWorker.postMessage({ action: 'skipWaiting' });
                }
            });
        });
    });
}
